// schema
import * as ISchema from "@schema";

import { RelayRefetchProp, RelayProp } from "react-relay";
import { IReduxState } from "@reducers/root.reducer";
import {
  makeEventSchedulerViewActive,
  updateFeedSchedulerInput,
  updateEventSchedulerHasUnsavedChanges,
  updateScheduledEventIds,
} from "@actions/feed-scheduler.actions";
import { setActiveViewDay, setActiveViewFeed } from "@actions/chrome-extension.actions";
import { setSelectedMoment, setSnapToSelectedMomentOnNextMount } from "@actions/day-view.actions";
import { EScheduleRange } from "@util/scheduler.util";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { EFlex } from "@util/event-tag.util";

import { styles } from "./EventScheduler.styles";
import { WithStyles } from "@material-ui/core/styles/withStyles";

export enum RoomOptionEnum {
  WithRoom = "WithRoom",
  WithoutRoom = "WithoutRoom",
  SpecificRoom = "SpecificRoom",
}

export enum VideoConferencingEnum {
  GoogleMeet = "GoogleMeet",
  Zoom = "Zoom",
  None = "None",
}

export interface IRendererProps {
  environment: typeof RelayProp["environment"];
}

export interface IContainer {
  viewer: ISchema.IViewer;
}

export interface IProps extends IContainer, WithStyles<typeof styles> {
  relay: RelayRefetchProp;
  updateFeedSchedulerInput: typeof updateFeedSchedulerInput;
  calendarIds: IReduxState["feedScheduler"]["calendarIds"];
  roomRequired: IReduxState["feedScheduler"]["roomRequired"];
  calendarSelectionStates: IReduxState["webExtension"]["calendarSelectionStates"];
  schedulingSessionId: IReduxState["feedScheduler"]["schedulingSessionId"];
  makeEventSchedulerViewActive: typeof makeEventSchedulerViewActive;
  setActiveViewDay: typeof setActiveViewDay;
  setActiveViewFeed: typeof setActiveViewFeed;
  setSelectedMoment: typeof setSelectedMoment;
  setSnapToSelectedMomentOnNextMount: typeof setSnapToSelectedMomentOnNextMount;
  snackBarOpen: typeof snackBarOpen;
  updateEventSchedulerHasUnsavedChanges: typeof updateEventSchedulerHasUnsavedChanges;
  updateScheduledEventIds: typeof updateScheduledEventIds;
  reschedulerEvent: IReduxState["feedScheduler"]["reschedulerEvent"];
  useAutoSchedule: IReduxState["feedScheduler"]["useAutoSchedule"];
  minutesDuration: IReduxState["feedScheduler"]["minutesDuration"];
  range: IReduxState["feedScheduler"]["range"];
  specifiedDate: IReduxState["feedScheduler"]["specifiedDate"];
}

export interface IState {
  title: string;
  calendarIds: string[];
  minutesDuration: number;
  includeRoom: RoomOptionEnum;
  range: EScheduleRange;
  specifiedDate: Date | null;
  roomIds: string[];
  description: string;
  location: string;
  includeZoomLink: boolean;
  selectedSlot?: ISchema.ISchedulingSlot;
  savingEvent: boolean;
  openingInGCal: boolean;
  focusEventTitle: boolean;
  titleError: string;
  timeError: string;
  uncrawledCalendarsCount: number;
  openRoomInput: boolean;
  useAutoSchedule: boolean;
  flex: EFlex;
  allowSimilarRooms: boolean;
  conflictResolutionDefragId?: string;
  allowedStart: ISchema.IDayOffsetTimeSlot | null;
  allowedEnd: ISchema.IDayOffsetTimeSlot | null;
  recurrenceOption?: ISchema.RecurrenceOption;
}
